module.exports = __webpack_public_path__ + "img/icon_empty_data.c6052a3a.png";